import { ProductUnit } from "./ProductUnit";

export class ProductUnitType implements IProductUnitType {
    constructor(productUnitType?: IProductUnitType) {
        this.units = [];
        if (productUnitType) {
            this.unitType = productUnitType.unitType;
            this.baseUnitCode = productUnitType.baseUnitCode;
            if (productUnitType.units)
                this.units = productUnitType.units.map((u) => new ProductUnit(u));
        }
    }

    unitType: string;
    baseUnitCode: string;
    units: ProductUnit[];
}

export interface IProductUnitType {
    unitType: string;
    baseUnitCode: string;
    units: ProductUnit[];
}